import { useQuery } from 'react-query';

import { PromptTemplateResponseDto } from '../../../../backend/src/prompt-template/dto/prompt-template.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetPromptTemplates = ({
  matterId,
  enabled = true,
}: {
  matterId: string | undefined;
  enabled?: boolean;
}) => {
  const fetcher = useFetcher();

  return useQuery<PromptTemplateResponseDto[]>(
    [QueryEntity.PromptTemplates],
    () => fetcher(`${APIBaseChronos}/api/matters/${matterId}/prompt-template`),
    {
      refetchOnWindowFocus: false,
      enabled: enabled && !!matterId,
    },
  );
};
